<template>
  <div>
    <PageHeader title="Transactions"></PageHeader>
    <v-container class="pa-0">
      <v-row>
        <v-col>
          <router-link :to="{name: 'buy-credits'}">Buy credits</router-link>
        </v-col>
        <v-col class="text-right">
          <router-link :to="{name: 'active-competitions'}">Competitions</router-link>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-simple-table>
            <template>
              <thead>
                <tr>
                  <th class="text-left">
                    Date
                  </th>
                  <th>
                    Desc
                  </th>
                  <th class="text-right">
                    CR
                  </th>
                  <th class="text-right">
                    DB
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="transaction in transactions" :key="transaction.id">
                  <td>{{transaction.dateCreated | moment("DD MMM YY")}}</td>
                  <td>{{transaction.notes}}</td>
                  <td class="text-right credit-text">{{ !transaction.isDebit ? transaction.amount: '' }}</td>
                  <td class="text-right debit-text">{{ transaction.isDebit ? transaction.amount: '' }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay
      :absolute="false"
      :value="overlay"
      :opacity="0.9"
      >
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'transactions',
  components: {
    PageHeader
  },
  data: () => ({
    overlay: false,
    transactions: []
  }),
  methods: {
    getTransactions: function () {
      this.overlay = true;
      var scope = this;
      this.$store.dispatch('getTransactions').then(response => {
        scope.transactions = response;
        scope.overlay = false;
      }, error => {
        this.overlay = false;
        console.log(error);
      });
    }
  },
  created () {
    this.getTransactions();
  }
}
</script>